import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import Button from 'components/app-components/ui/button';
import GenericModal from './GenericModal';

// For the back arrow on the first step of an onboarding wizard, where there is no earlier screen.
export const BACK_LOGS_OUT_TITLE = 'Going back will log you out. Anything you have filled in so far will be lost.';

interface PromptLogoutModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  isProcessing?: boolean;
}

const PromptLogoutModal = ({ open, onClose, onConfirm, title, isProcessing = false }: PromptLogoutModalProps) => {
  return (
    <GenericModal open={open} onClose={onClose} width="max-w-md" showHeaderBorder={false} isProcessing={isProcessing}>
      <div className="flex">
        <ExclamationCircleIcon className="mr-2 mt-0.5 h-6 w-6 text-red-600" />
        <h3 className="mb-5 text-base font-normal text-neutral-500">{title}</h3>
      </div>
      <div className="flex justify-end gap-4">
        <Button variant="outline" onClick={onClose} disabled={isProcessing}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={onConfirm}
          loading={isProcessing}
          className="!border-red-600 !bg-red-600 hover:!bg-red-700 focus:ring-red-500"
        >
          Confirm
        </Button>
      </div>
    </GenericModal>
  );
};

export default PromptLogoutModal;
